import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

function Header() {
  const { t, i18n } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "en";
    i18n.changeLanguage(savedLanguage);
  }, [i18n]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  const toggleMobileMenu = () => {
    const body = document.body;
    setMobileMenuOpen(!mobileMenuOpen);
    body.style.overflowY = !mobileMenuOpen ? "hidden" : "auto";
  };

  const handleLogoClick = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  const handleNavClick = (hash) => {
    if (location.pathname !== "/") {
      sessionStorage.setItem("scrollTo", hash);
      navigate("/");
    } else {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }

    if (mobileMenuOpen) {
      toggleMobileMenu();
    }
  };

  const labels = [
    t("nav.about"),
    t("nav.modules"),
    t("nav.implementation"),
    t("nav.contacts"),
  ];

  return (
    <div style={{ zIndex: 300 }} className="sticky top-0">
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-200"
          onClick={toggleMobileMenu}
        ></div>
      )}

      <header
        className="relative bg-white shadow z-300"
        style={{ zIndex: 100000, position: "relative" }}
      >
        <div className="max-w-[1160px] mx-auto flex justify-between items-center py-1 px-2 md:px-4 w-full">
          <div className="lg:w-auto lg:h-auto relative z-300">
            <button onClick={handleLogoClick} className="focus:outline-none">
              <img
                src="/img/diguni-logo1.svg"
                alt="diguni logo"
                className="w-[87px] h-[20px] md:w-[120px] md:h-[20px] lg:w-[146px] lg:h-[24px]"
              />
            </button>
          </div>

          <nav
            className="hidden md:flex md:gap-12 lg:gap-16 items-center py-2"
            style={{ fontWeight: "200" }}
          >
           {["#about", "#modules", "#implementation", "#contacts"].map((section, index) => (
              <button
                key={index}
                onClick={() => handleNavClick(section)}
                className="text-gray-700 text-[18px] lg:text-[18px] hover:text-black"
              >
                {labels[index]}
              </button>
            ))}
          </nav>

          <div className="lg:flex lg:gap-2 flex items-center">
            <a
              onClick={() => changeLanguage("en")}
              className="hidden md:block bg-light-gray text-[18px] py-1 px-3 rounded uppercase text-white transition-all duration-300 hover:bg-gray-600"
            >
              ENG
            </a>
            <a
              onClick={() => changeLanguage("uk")}
              className="hidden md:block bg-light-gray text-[18px] py-1 px-3 rounded uppercase text-white transition-all duration-300 hover:bg-gray-600"
            >
              UK
            </a>
          </div>

          <div className="block md:hidden z-[300] relative">
            <button className="flex items-center" onClick={toggleMobileMenu}>
              <i
                className={`fa ${
                  mobileMenuOpen ? "fa-times" : "fa-bars"
                } text-2xl`}
              ></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="fixed h-[400px] inset-0 bg-white z-200 flex flex-col items-center justify-center gap-6 text-center right-0">
            {["#about", "#modules", "#implementation", "#contacts"].map(
              (section, index) => (
                <a
                  key={index}
                  href={section}
                  className="text-gray-700 text-[18px] lg:text-[18px] hover:text-black"
                  onClick={toggleMobileMenu}
                >
                  {labels[index]}
                </a>
              )
            )}
            <a
              onClick={() => {
                changeLanguage("en");
                toggleMobileMenu();
              }}
              className="bg-light-gray text-[18px] py-1 px-3 rounded uppercase text-white transition-all duration-300 hover:bg-gray-600"
            >
              ENG
            </a>
            <a
              onClick={() => {
                changeLanguage("uk");
                toggleMobileMenu();
              }}
              className="bg-light-gray text-[18px] py-1 px-3 rounded uppercase text-white transition-all duration-300 hover:bg-gray-600"
            >
              UK
            </a>
          </div>
        )}
      </header>
    </div>
  );
}

export default Header;
